import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Detector } from 'react-detect-offline'
import cx from 'classnames'

import CloseButton from '../CloseButton'

import { LOCALE_PREFIX } from './constants'

import './style.scss'
import config from '../../config'

const showTimeout = 10000

export default class ConnectionChecker extends Component {
    constructor() {
        super()

        this.state = {
            connected: true,
            showToast: false,
        }
    }

    connectionChange = (connected) => {
        this.setState({
            connected,
        })
    }

    changeShowToast = (show) => {
        this.setState({
            showToast: show,
        })
    }

    handleCloseBtnClick = () => {
        this.setState({
            showToast: false,
        })
    }

    componentDidUpdate(nextProps, prevState) {
        const { connected: nextStatus } = this.state
        const { connected: previousStatus } = prevState

        if ((!previousStatus && nextStatus) || (previousStatus && !nextStatus)) {
            this.changeShowToast(true)

            setTimeout(() => this.changeShowToast(false), showTimeout)
        }
    }

    render() {
        const { connected, showToast } = this.state
        const pingUrl = config.api.ping.uri
        const polling = { url: pingUrl, timeout: 5000 }

        return (
            <div className={'connection-detector'}>
                <Detector onChange={this.connectionChange} render={() => null} polling={polling} />
                {showToast && (
                    <div className={cx('connection-toast', connected ? 'online' : 'offline')}>
                        <div className={'msg-wrapper'}>
                            <i className={'icon'} />
                            <FormattedMessage id={`${LOCALE_PREFIX}.${connected ? 'online' : 'offline'}`} />
                        </div>
                        <CloseButton onClick={this.handleCloseBtnClick} pad={2} size={14} />
                    </div>
                )}
            </div>
        )
    }
}
